import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
} from '@mui/material';
import {
  Visibility,
  Delete,
  GetApp,
} from '@mui/icons-material';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

export default function TRespuestas({ rows, termp, onRespuestaEliminada }) {
  const [dialogoDetalle, setDialogoDetalle] = useState(false);
  const [dialogoEliminar, setDialogoEliminar] = useState(false);
  const [selectedRespuesta, setSelectedRespuesta] = useState(null);

  const verDetalle = (respuesta) => {
    setSelectedRespuesta(respuesta);
    setDialogoDetalle(true);
  };

  // const eliminarRespuesta = (respuesta) => {
  //   setSelectedRespuesta(respuesta);
  //   setDialogoEliminar(true);
  // };

  // const confirmarEliminacion = async () => {
  //   try {
  //     // TODO: Aquí llamar a tu API para eliminar la respuesta
  //     // await eliminarRespuestaApi(selectedRespuesta.respuestaEncuestaId);
      
  //     onRespuestaEliminada(selectedRespuesta.respuestaEncuestaId);
  //     setDialogoEliminar(false);
  //     setSelectedRespuesta(null);
  //   } catch (error) {
  //     console.error('Error al eliminar respuesta:', error);
  //   }
  // };

  const exportarRespuesta = (respuesta) => {
    console.log('Exportando respuesta:', respuesta);
    // Implementar lógica de exportación aquí
  };

  const formatearFecha = (fecha, formato = 'dd/MM/yyyy HH:mm') => {
    try {
      return format(new Date(fecha), formato, { locale: es });
    } catch {
      return fecha;
    }
  };

  const respuestasFiltradas = rows.filter(respuesta => {
    if (!termp) return true;
    
    const termLower = termp.toLowerCase();
    
    // Convertir la fecha de la respuesta a un formato comparable
    const fechaRespuestaFormateada = formatearFecha(respuesta.fechaRespuesta, 'dd/MM/yyyy').toLowerCase();
    
    return (
      respuesta.nombreCompletoCliente?.toLowerCase().includes(termLower) ||
      respuesta.nombreUsuario?.toLowerCase().includes(termLower) ||
      fechaRespuestaFormateada.includes(termLower)
    );
  });

  return (
    <>
      <TableContainer component={Paper} style={{ marginTop: 20 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Cliente</TableCell>
              <TableCell>Usuario que respondió</TableCell>
              <TableCell>Fecha de Respuesta</TableCell>
              <TableCell align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {respuestasFiltradas.length > 0 ? (
              respuestasFiltradas.map((respuesta) => (
                <TableRow key={respuesta.respuestaEncuestaId} hover>
                  <TableCell>
                    <Typography variant="body2">
                      {respuesta.nombreCompletoCliente || 'Cliente Anónimo'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                      {respuesta.nombreUsuario || '-'}
                  </TableCell>
                  <TableCell>
                    {formatearFecha(respuesta.fechaRespuesta)}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      aria-label="ver detalle"
                      onClick={() => verDetalle(respuesta)}
                      size="small"
                      color="primary"
                    >
                      <Visibility />
                    </IconButton>
                    {/* <IconButton
                      aria-label="exportar"
                      onClick={() => exportarRespuesta(respuesta)}
                      size="small"
                      color="secondary"
                    >
                      <GetApp />
                    </IconButton> */}
                    {/* <IconButton
                      aria-label="eliminar"
                      onClick={() => eliminarRespuesta(respuesta)}
                      size="small"
                      style={{ color: 'red' }}
                    >
                      <Delete />
                    </IconButton> */}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography variant="body2" color="textSecondary">
                    {termp ? 'No se encontraron respuestas que coincidan con la búsqueda' : 'No hay respuestas disponibles'}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Diálogo de detalle (sin cambios) */}
      <Dialog 
        open={dialogoDetalle} 
        onClose={() => setDialogoDetalle(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Detalle de la Respuesta
        </DialogTitle>
        <DialogContent>
          {selectedRespuesta && (
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2">Cliente:</Typography>
                <Typography variant="body2">{selectedRespuesta.nombreCompletoCliente || 'Anónimo'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2">Usuario que respondió:</Typography>
                <Typography variant="body2">{selectedRespuesta.nombreUsuario || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2">Fecha:</Typography>
                <Typography variant="body2">
                  {formatearFecha(selectedRespuesta.fechaRespuesta)}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2">Respuestas:</Typography>
                {selectedRespuesta.respuestas?.map((resp, index) => (
                  <Paper key={index} style={{ padding: 10, margin: '8px 0' }}>
                    <Typography variant="body2">
                      <strong>Pregunta {index + 1}:</strong> {resp.textoPregunta}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Respuesta:</strong> {resp.opcionSeleccionada?.texto || 'No respondida'}
                    </Typography>
                  </Paper>
                )) || (
                  <Typography variant="body2" color="textSecondary">
                    No se encontraron respuestas detalladas
                  </Typography>
                )}
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogoDetalle(false)}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo de confirmación de eliminación (sin cambios) */}
      {/* <Dialog
        open={dialogoEliminar}
        onClose={() => setDialogoEliminar(false)}
      >
        <DialogTitle>Confirmar Eliminación</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Estás seguro de que deseas eliminar esta respuesta? Esta acción no se puede deshacer.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogoEliminar(false)}>
            Cancelar
          </Button>
          <Button onClick={confirmarEliminacion} color="error" variant="contained">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog> */}
    </>
  );
}